import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { getServiceTypeList } from "../Actions/CommonAPI";
import MMPLShipCard from "./PendingShipCard";
import { toast } from "react-toastify";
import {
  getPendingShipCount,
} from "../Actions/ApproverScreenAPI";
import DatePicker from "react-datepicker";
import Role from "../helpers/role";
import FileSaver from "file-saver";
import Moment from "moment";
import { getMDSearchlist } from "../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import {
  getShipSearchlist,
  getMMPLShipCount,
  getMMPLShipDeatil,
  exportToExcel,
  getpendingShipSearchlist,
} from "../Actions/MMPLDashboardAPI";

import CountUp from "react-countup";
import { AutoComplete } from "primereact/autocomplete";
import { Multiselect } from "multiselect-react-dropdown";
import MapCharts from "./Mapchart";
import axios from "axios";
import API from "../helpers/api";
import moment from "moment";
import $ from "jquery";

let userrole = localStorage.getItem("UserRoles");
class PendingShipsDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSidePane: false,
      clientList: [],
      SelectedFromDate: "",
      SelectedToDate: "",
      fromDate: "",
      allShipo: 100,
      expiredShips: 99,
      expiringShips: 50,
      toDate: "",
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      filterTitle: "All Ships",
      action: 1,
      portValue: [],
      originalPortData: {},
      markers: [],
      searchShip: {
        IsClient: false,
        shipName: "",
        category: "",
        imoNo: "",
        client: "",
        status: "alldrafts",
        serviceStatus: "",
        nextServiceDateFrom: "",
        nextServiceDateTo: "",
        pagesize: 25,
        pagenumber: 1,
        noofrecords: 2,
        ServiceTypes: [],
        isTotalShips: true,
        isOverdueShips: false,
        isShipsDue10: false,
        isShipsDue30: false,
        isShipsDue60: false,
        isShipsDue90: false,
        action: 1,
      },
      shipData: {
        IsClient: false,
        mail: "",
        shipName: "",
      },
      inContract: false,
      notInContract: false,
      isBoth: true,
      selectedServiceTypes: [],
      EquipmentList: ["A_Equipment1", "B_Equipment2", "C_Equipment"],
      serviceType: [],
      PageNo: 1,
    };
    this.multiSelectRef = React.createRef()
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onRemoveChange = this.onRemoveChange.bind(this);
    this.SearchMMPLData = this.SearchMMPLData.bind(this);
    this.ClearSearchField = this.ClearSearchField.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onChangeClientName = this.onChangeClientName.bind(this);
  }

  componentDidMount() {

    const { dispatch, searchData, searched, PendingShipsearchData,t } = this.props;
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "Pending Ship Dashboard",
    });
    this.getClientList();
    let user = localStorage.getItem("UserRoles");
    if (user == Role.approver) {
      let currentuser = JSON.parse(localStorage.getItem("currentUser"));
      dispatch(getPendingShipCount(currentuser));
    }

    if (userrole === "mmpl") {
      this.state.searchShip.status = "Pending";
      this.setState({});
    }
    if (userrole === "approver") {
      this.state.searchShip.status = "Approver approval pending";
      this.setState({});
    }
    if (searchData) {

      this.state.searchShip = searchData;
      if (userrole === "mmpl") {
        this.state.searchShip.status = "Pending";
        this.setState({});
      }
      if (userrole === "approver") {
        this.state.searchShip.status = "Approver approval pending";
        this.setState({});
      }
      if (searchData.ServiceTypes != "") {
        this.state.selectedServiceTypes = searchData.ServiceTypes.split(",");
      }
      if (searched !== true) {
        this.ClearSearchField(false);
        // dispatch({ type: "PendingsearchData", data: "" });
      }
    }

    dispatch(getpendingShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth, true));

    dispatch({ type: "Pendingsearched", data: false });

    let searchitem = this.state.searchShip;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;
      // if (
      //   searchitem.shipName ||
      //   searchitem.client ||
      //   searchitem.imoNo ||
      //   searchitem.ServiceTypes.length > 0 ||
      //   searchitem.nextServiceDateFrom ||
      //   searchitem.nextServiceDateTo
      // ) {
      if (keycode === 13) {
        if (_this.verifySearchItems()) {
          _this.SearchMMPLData(1, 2);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  getClientList = () => {
    let url = `${API.Clientlist}`;
    axios
      .get(url)
      .then((response) => {
        this.state.clientList = response.data.clients;
        this.setState({})
      })
      .catch((error) => {
        console.log(error);
      });
  };

  onChangeClientName = (event, value) => {
    this.setState({
      searchShip: {
        ...this.state.searchShip,
        client: value,
      },
    });
  };
  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchShip[nodeName] = e.target.value;
    this.setState({});
  }

  serviceTypeChange(item, e) {
    let checked = [];
    checked = this.state.serviceType;
    if (e.target.checked) {
      checked.push({
        checkboxValue: item,
      });
      if (item === "Annual") {
        this.state.searchShip.Annually = true;
      } else if (item === "Biannual") {
        this.state.searchShip.Biannually = true;
      } else if (item === "Five yearly") {
        this.state.searchShip.FiveYearly = true;
      } else if (item === "Ten yearly") {
        this.state.searchShip.Tenyearly = true;
      }
    } else {
      const index = checked.findIndex((ch) => ch.checkboxValue === item);
      checked.splice(index, 1);
      if (item === "Annual") {
        this.state.searchShip.Annually = false;
      } else if (item === "Biannual") {
        this.state.searchShip.Biannually = false;
      } else if (item === "Five yearly") {
        this.state.searchShip.FiveYearly = false;
      } else if (item === "Ten yearly") {
        this.state.searchShip.Tenyearly = false;
      }
    }
    this.setState({ serviceType: checked });
    this.setState({});
  }

  suggestMItable(event) {
    let results = this.state.EquipmentList.filter((table) => {
      return table.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ EquipmentList: results });
  }

  SearchMMPLData(pgno, noof) {

    const { dispatch } = this.props;
    const { searchShip, selectedServiceTypes } = this.state;
    searchShip["noofrecords"] = noof;
    searchShip["pagenumber"] = pgno;
    searchShip.ServiceTypes = selectedServiceTypes.join(",");
    this.setState(
      {
        searchShip: searchShip,
        filterShiplist: true,
      },
      () => {
        dispatch({ type: "PendingsearchData", data: this.state.searchShip });
        dispatch(getpendingShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth, true));
        this.setState({});
      }
    );
  }

  verifySearchItems = () => {
    let flag = true;
    const search = this.state.searchShip;
    if (search.shipName == "" && search.client == "" && search.imoNo == "" && this.state.selectedServiceTypes.length == 0 && search.status == "alldrafts") {
      flag = false;
    }
    return flag;
  }

  SearchMMPLData1(pgno, noof) {
    const { dispatch, t } = this.props;
    if (this.verifySearchItems()) {

      const { searchShip, selectedServiceTypes } = this.state;
      searchShip["noofrecords"] = noof;
      searchShip["pagenumber"] = pgno;
      searchShip.ServiceTypes = selectedServiceTypes.join(",");
      this.setState(
        {
          searchShip: searchShip,
          filterShiplist: true,
        },
        () => {
          dispatch({ type: "PendingsearchData", data: this.state.searchShip });
          dispatch(getpendingShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth, true));
          this.setState({});
        }
      );
    }
    else {
      toast.success(t('Toast.Success'), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  onSelectChange = (item) => {
    this.setState({ selectedServiceTypes: item });
  };

  onRemoveChange(item) {
    this.setState({ selectedServiceTypes: item });
  }

  ClearSearchField(search) {
    const { dispatch } = this.props;
    if (userrole === "approver") {
      this.state.searchShip.status = "Approver approval pending";
      this.setState({});
    }
    if (userrole === "admin") {
      this.state.searchShip.status = "alldrafts";
      this.setState({});
    }
    this.setState(
      {
        searchShip: {
          IsClient: false,
          shipName: "",
          category: "",
          imoNo: "",
          client: "",
          serviceStatus: "",
          nextServiceDateFrom: "",
          status: this.state.searchShip.status,
          nextServiceDateTo: "",
          noofrecords: 2,
          pagesize: 25,
          pagenumber: 1,
          ServiceTypes: [],
          isTotalShips: this.state.searchShip.isTotalShips,
          isOverdueShips: this.state.searchShip.isOverdueShips,
          isShipsDue10: this.state.searchShip.isShipsDue10,
          isShipsDue30: this.state.searchShip.isShipsDue30,
          isShipsDue60: this.state.searchShip.isShipsDue60,
          isShipsDue90: this.state.searchShip.isShipsDue90,
          action: this.state.searchShip.action,
        },
        EquipmentName: "",
        selectedServiceTypes: [],
      },
      () => {
        if (search) {
          dispatch({ type: "PendingsearchData", data: "" });
          this.state.selectedServiceTypes = [];
          this.setState({});
          dispatch(getpendingShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth));
        }
      }
    );
    dispatch({ type: "PendingsearchData", data: "" });
    this.multiSelectRef.current.resetSelectedValues()
  }

  render() {
    const {
      mmplShipSearchResult,
      mmplShipInfo,
      showSidePane,
      serviceTypeList,
      ShipStatusList,
      t
    } = this.props;
    const {
      isTotalShips,
      isOverdueShips,
      isShipsDue10,
      isShipsDue30,
      isShipsDue60,
      isShipsDue90,
    } = this.state.searchShip;
    const { selectedServiceTypes } = this.state;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className="card MM-card-header  mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          {t("PendingShipScreenContent.PendingShipSearch")}
                        </h5>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6" : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t("content.Shipname")}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="shipName"
                            onChange={(e) => this.handleInputChange(e)}
                            value={this.state.searchShip.shipName}
                            placeholder={t("content.Shipname")}
                          ></input>
                        </div>
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t("content.Client")}</label>
                          <br></br>
                          <Autocomplete
                            value={this.state.searchShip.client}
                            options={this.state.clientList}
                            getOptionLabel={(option) => option || ""}
                            onChange={(event, value) => {
                              this.onChangeClientName(event, value);
                            }}
                            noOptionsText={"No options to display"}
                            freeSolo={false}
                            disableClearable
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                className="form-control"
                                id="margin-dense"
                                style={{ marginTop: -1 }}
                                margin="dense"
                                size="small"
                                variant="outlined"
                                placeholder={t('content.Client')}
                              />
                            )}
                          />
                        </div>
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t("content.IMOno")}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="imoNo"
                            placeholder={t("content.IMOno")}
                            onChange={(e) => this.handleInputChange(e)}
                            value={this.state.searchShip.imoNo}
                          ></input>
                        </div>
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t('content.Servicetype')}</label>
                          <Multiselect
                            options={serviceTypeList ?? []}
                            ref={this.multiSelectRef}
                            showArrow={true}
                            isObject={false}
                            style={{
                              option: {
                                marginRight: 0,
                                display: "block",
                                fontWeight: "normal",
                              },
                              chips: { "background-color": "#1a3464" },
                            }}
                            onSelect={(item) => this.onSelectChange(item)}
                            onRemove={(item) => this.onRemoveChange(item)}
                            selectedValues={selectedServiceTypes}
                            placeholder={
                              this.state.selectedServiceTypes &&
                                this.state.selectedServiceTypes.length
                                ? ""
                                : `${t('content.Select')}`
                            }
                            closeIcon="cancel"
                          />
                        </div>
                        {userrole === "admin" ?
                          <div
                            className={
                              this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                            }
                          >
                            <label className="form-label ">{t("EquipmentServiceTypes.Status")}</label>
                            <br></br>
                            <select
                              className="form-control"
                              name="status"
                              value={this.state.searchShip.status}
                              onChange={(e) => this.handleInputChange(e)}
                            > <option value="">{t("ContractManagementContent.SelectStatus")}</option>
                              {ShipStatusList &&
                                ShipStatusList.map((Value) => (
                                  <option value={Value.name}>
                                    {Value.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                          : null}
                      </div>
                      <div className="row">
                        <div
                          className={
                            showSidePane ? "col-sm-12 mt-4" : "col-lg-12 mt-4"
                          }
                        >
                          <div
                            className="form-group search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                              type="submit"
                              onClick={() => this.SearchMMPLData1(1, 2)}
                            >
                              {" "}
                              {t('content.Search')}{" "}
                            </button>

                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearSearchField(true)}
                            >
                              {" "}
                              {t('content.Clear')}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {mmplShipSearchResult ? (
                <MMPLShipCard
                  currentPage={(mmplShipSearchResult.pagination.currentPage - 1) * mmplShipSearchResult.pagination.pageSize}
                  arraylist={mmplShipSearchResult}
                  pageSize={mmplShipSearchResult.pagination.pageSize}
                  totalRecords={
                    mmplShipSearchResult.pagination.totalcount
                      ? mmplShipSearchResult.pagination.totalcount
                      : 0
                  }
                  setUpdatedState={(value, records) =>
                    this.SearchMMPLData(value, records)
                  }
                  shipMMPLInfo={mmplShipInfo}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    arraylist: state.SidePanReducer.arraylist,
    showSidePane: state.SidePanReducer.sidePan || false,
    searchData: state.SidePanReducer.PendingsearchData,

    searched: state.SidePanReducer.Pendingsearched || false,
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,
    //BY BALU MOORTHI

    mmplShipDetail: state.MMPLDashboardReducer.MMPLShipDetail || {},
    mmplShipSearchResult:
      state.MMPLDashboardReducer.MMPLPendingShipSearchResult || null,
    mmplShipInfo: state.MMPLDashboardReducer.MMPLShipInfo || {},
    ShipStatusList: state.MasterScreenReducer.ShipStatusList,
    serviceTypeList:
      state.MasterScreenReducer.applicableServiceTypeInterval || [],

  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(PendingShipsDashboard));
